import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Crown, ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import { clubInfo, MbtiBadge } from "@/lib/mbti";

export default function WeeklyClubMVPs() {
  const [data, setData] = useState(null);
  const [week, setWeek] = useState(null);

  useEffect(() => {
    fetchWeek(null);
  }, []);

  const fetchWeek = async (w) => {
    const qs = w ? `?week=${w}` : "";
    const { data: res } = await api.get(`/weekly-mvps${qs}`);
    setData(res);
    setWeek(res.week);
  };

  if (!data) return null;

  const change = (delta) => {
    const lo = data.competition_start_week || 1;
    const hi = data.competition_end_week || data.weeks_total;
    const next = Math.max(lo, Math.min(hi, week + delta));
    if (next !== week) fetchWeek(next);
  };
  const lo = data.competition_start_week || 1;
  const hi = data.competition_end_week || data.weeks_total;
  const compIndex = data.competition_index || week;

  return (
    <div className="kw-card p-6" data-testid="weekly-club-mvps">
      <div className="flex items-center justify-between mb-6 border-b border-[#222] pb-4">
        <div className="flex items-center gap-3">
          <Sparkles className="w-6 h-6 text-[#E50000]" />
          <div>
            <div className="kw-overline">Reconhecimento semanal</div>
            <h2 className="font-display text-2xl font-black uppercase">MVPs por Clube · Semana {compIndex}</h2>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <button onClick={() => change(-1)} disabled={week <= lo}
            className="kw-btn-secondary !px-3 !py-2 disabled:opacity-30" data-testid="mvp-prev-week">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <div className="font-display text-lg font-black px-3 min-w-[60px] text-center">{compIndex}/{data.competition_weeks || data.weeks_total}</div>
          <button onClick={() => change(1)} disabled={week >= hi}
            className="kw-btn-secondary !px-3 !py-2 disabled:opacity-30" data-testid="mvp-next-week">
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>

      {data.phase === "preparation" && (
        <div className="mb-5 border border-[#EAB308]/40 bg-[#EAB308]/5 px-4 py-3 text-xs uppercase tracking-widest text-[#EAB308]"
          data-testid="mvp-preseason-note">
          Fase de preparação — os MVPs começam a contar na semana 1 de coopetição
        </div>
      )}

      {data.in_progress && data.phase !== "preparation" && (
        <div className="mb-5 border border-[#3B82F6]/40 bg-[#3B82F6]/5 px-4 py-3 text-xs uppercase tracking-widest text-[#3B82F6]"
          data-testid="mvp-in-progress-note">
          Semana em curso — quem aparece aqui é líder provisório; o MVP fica decidido no fecho, domingo às 23:59
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {data.winners.map((w) => {
          const info = clubInfo(w.club);
          const empty = !w.name;
          return (
            <div
              key={w.club}
              data-testid={`mvp-${w.club.toLowerCase()}`}
              className="kw-card p-5 relative overflow-hidden"
              style={{ borderColor: info?.border, background: empty ? "#101010" : `linear-gradient(180deg, ${info?.bg} 0%, #0A0A0A 70%)` }}
            >
              <Crown
                className="absolute -top-3 -right-3 w-20 h-20 opacity-10"
                style={{ color: info?.color }}
              />
              <div className="kw-overline mb-1" style={{ color: info?.color }}>
                {w.title}
              </div>
              {empty ? (
                <div className="py-6 text-[#737373] text-sm">
                  Ainda sem atividade dos coopetidores {w.club} nesta semana.
                </div>
              ) : (
                <>
                  <div className="font-display text-3xl font-black uppercase tracking-tight mt-2 leading-tight">
                    {w.name}
                  </div>
                  <div className="mt-2 mb-4">
                    <MbtiBadge mbti={w.mbti} label={w.personality_label} />
                  </div>
                  <div className="flex items-baseline gap-2 mb-4">
                    <div className="font-display text-4xl font-black" style={{ color: info?.color }}>
                      {Math.round(w.points)}
                    </div>
                    <div className="kw-overline">pts semana</div>
                  </div>
                  <div className="grid grid-cols-4 gap-1 text-center">
                    <Mini label="V" value={w.vendas} />
                    <Mini label="A" value={w.angariacoes} />
                    <Mini label="R" value={w.reunioes} />
                    <Mini label="C" value={w.contactos} />
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Mini({ label, value }) {
  return (
    <div className="border border-[#222] py-1.5">
      <div className="font-display text-lg font-black">{value}</div>
      <div className="kw-overline text-[9px]">{label}</div>
    </div>
  );
}
